var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useFilterStore } from "./store";
import { hidePreloader, showPreloader } from "../../components/preloader";
import { updateHtml } from "../../components/pager";
import { getFetchOptions } from "../../utils";
var DELAY = 750;
export default function useFilterAPI() {
    var store = useFilterStore();
    var requestId = 0;
    var abortController;
    var delayTimeout;
    function request(url, params, options) {
        if (params === void 0) { params = {}; }
        if (options === void 0) { options = {}; }
        var currentRequestId = ++requestId;
        return fetch(url, __assign(__assign({}, getFetchOptions(Object.assign(params, {
            values: store.values,
            config: store.config,
        }), true)), options))
            .then(function (response) { return requestId > currentRequestId ? Promise.reject('concurrency error') : response; })
            .then(function (response) { return response.json(); })
            .then(function (json) {
            if (json.items) {
                store.update(json.items);
            }
            if (json.sort) {
                store.setDefaultSort(json.sort.default);
                store.setSortType(json.sort.type);
                store.setSortTypes(json.sort.types);
            }
            return json;
        })
            .catch(function (reason) {
            if (reason === 'concurrency error') {
                return {};
            }
        })
            .finally(function () { return store.setLoaded(true); });
    }
    function updateResults(status, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.page, page = _c === void 0 ? 1 : _c, _d = _b.pager, pager = _d === void 0 ? false : _d, _e = _b.loadMore, loadMore = _e === void 0 ? false : _e, _f = _b.lockFilter, lockFilter = _f === void 0 ? false : _f, _g = _b.pushState, pushState = _g === void 0 ? true : _g, url = _b.url;
        showPreloader(pager ? undefined : (lockFilter ? document.getElementById('filter-area') : document.querySelector('.catalog_items')));
        return request('/api/filter/results', { status: status, page: page }, abortController ? { signal: abortController.signal } : {})
            .then(function (response) {
            if (response && response.pager !== undefined && response.results !== undefined) {
                abortController = null;
                updateHtml(response.results, pager && !loadMore, response.pager, loadMore);
                url = url !== null && url !== void 0 ? url : response.url;
                if (pushState && url !== undefined && url !== document.location.search) {
                    var state = {
                        config: __assign({}, store.config),
                        values: __assign({}, store.values),
                        page: page,
                        title: document.querySelector('h1').innerText,
                        html: response.results,
                        pagerHtml: response.pager,
                        available: store.available,
                    };
                    window.history.pushState(state, null, url === '' ? './' : url);
                }
                hidePreloader();
            }
            return response;
        });
    }
    function cancelTimeout() {
        if (delayTimeout) {
            clearTimeout(delayTimeout);
            delayTimeout = null;
        }
    }
    function updateResultsDelayed(status) {
        return new Promise(function (resolve, reject) {
            cancelTimeout();
            if (abortController) {
                abortController.abort('cancelled');
            }
            var ac = abortController = new AbortController();
            abortController.signal.addEventListener('abort', function () {
                cancelTimeout();
                reject('cancelled');
            });
            delayTimeout = setTimeout(function () {
                if (ac.signal.aborted) {
                    reject('cancelled');
                }
                delayTimeout = null;
                updateResults(status)
                    .then(function (response) { return resolve(response); });
            }, DELAY);
        });
    }
    return {
        request: request,
        updateResults: updateResults,
        updateResultsDelayed: updateResultsDelayed
    };
}
